
export const invites = {
    invitationCode: '邀请码',
    enterInvitationCode: '输入邀请码',
    copied: '已复制！',
    copyInvitationLink: '复制邀请链接',
    inviteRewardDescription: '邀请1位好友注册 Catoo，奖励{amount}积分，好友消费更有额外积分奖赏。',
    invitationRewardBalance: '奖励积分',
    totalInvitationCount: '总邀请数',
    monthlyReferrals: '本月邀请数',
    totalPaidCount: '总付费数',
    totalAwardAmount: '总奖励金额',
    registrationReward: '注册奖励',
    invitationReward: '好友消费奖励',
    invitationRecords: '邀请记录',
    invitationTime: '邀请时间',
    invitedUser: '被邀请用户',
    email: '邮箱',
    status: '状态',
    rewardAmount: '奖励金额',
    rewardCredits: '奖励积分',
    unknownUser: '未知用户',
    completed: '已完成',
    pending: '待完成',
    noInvitationRecords: '暂无邀请记录'
  };
